import { giphyBlue, giphyRed } from '@giphy/js-brand'
import styled from 'styled-components'

const Icon = styled.div`
    align-items: center;
    border-radius: 50%;
    color: #fff;
    display: flex;
    flex-shrink: 0;
    font-size: 16px;
    height: 30px;
    justify-content: center;
    margin-left: 8px;
    width: 30px;

    i {
        margin-top: 2px;
    }
`

export const GiphyIcon = () => (
    <Icon style={{ backgroundColor: '#000' }}>
        <svg width="13" height="16" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <path d="M10.811 5.333h1.802v8.89h-1.802z" fill="#93F" />
                <path d="M0 14.222h12.613V16H0z" fill="#0CF" />
                <path d="M0 1.778h1.802v12.444H0z" fill="#0F9" />
                <path d="M0 0h7.207v1.778H0z" fill="#FFF35C" />
                <path d="M10.811 3.556V1.778H9.01V0H7.207v5.334H12.613V3.555z" fill="#F66" />
                <path d="M7.207 0v1.778H5.406zM10.811 7.129V5.333h1.802z" fill="#0F0F0F" opacity=".4" />
            </g>
        </svg>
    </Icon>
)

export const YoutubeIcon = () => (
    <Icon style={{ backgroundColor: giphyRed }}>
        <i className="ss-social ss-youtube" />
    </Icon>
)

export const VimeoIcon = () => (
    <Icon style={{ backgroundColor: giphyBlue }}>
        <i className="ss-social ss-vimeo" />
    </Icon>
)
